import { LanguageService } from './../../../Services/languageService';
import { Subscription } from 'rxjs';
import { userService } from './../../../Services/userService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component, ViewChild, ElementRef, Renderer } from '@angular/core';
import { restURL } from '../../../Models/restURL';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import { renewalProposalService } from '../../../Services/renewalProposalService';
import { mdlPremiumAndVehicleInfoCompRenewalRes } from '../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes';
import { mdlProposalAddCompRenewalReq } from '../../../Models/mdlProposalAddCompRenewalReq';
import { mdlPolicyDetailsCompRenewal } from '../../../Models/mdlPolicyDetailsCompRenewal';
import { mdlProposalAddCompRenewalRes } from '../../../Models/mdlProposalAddCompRenewalRes';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { PayfortTransInfoModel } from '../../../Models/ProposalModel';
import { TranslateService } from '@ngx-translate/core';


declare let $: any;
@Component({
  selector: 'CompRenewalReviewConfirm',
  templateUrl: './CompRenewalReviewConfirm.html',
  styleUrls: ['./CompRenewalReviewConfirm.css']
})
export class CompRenewalReviewConfirm {

  public IBAN1: string;
  public IBAN2: string;
  public IBAN3: string;
  public IBAN4: string;
  public IBAN5: string;
  public IBAN6: string;
  public policyNo: string;
  public showEmailValidation: boolean;
  public showEmailRequired: boolean;

  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public ShowHigherPositionFeild: boolean = false;
  public isSubmitted: boolean = false;
  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public Lng: string;
  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
  public policyInfo: mdlPolicyDetailsCompRenewal = new mdlPolicyDetailsCompRenewal();
  public proposalAddCompRenewalReq: mdlProposalAddCompRenewalReq = new mdlProposalAddCompRenewalReq();
  public objAddProposalRes: mdlProposalAddCompRenewalRes = new mdlProposalAddCompRenewalRes();
  public objPremiumAndVehicleInfoRes: mdlPremiumAndVehicleInfoCompRenewalRes = new mdlPremiumAndVehicleInfoCompRenewalRes();

  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
  public agreeNatAdd: boolean;
  constructor(private translate: TranslateService,private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private renderer: Renderer, private trackingObj: MotorproposalTrackingService, private userinfo: userService, private lngService: LanguageService) {
    this.showEmailValidation = false;
    this.showEmailRequired = false;
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng
    });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    //this.objPremiumAndVehicleInfoRes = JSON.parse(sessionStorage.getItem("objPremiumAndVehicleInfoRes"));
    this.objPremiumAndVehicleInfoRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objPremiumAndVehicleInfoRes")));
    this.proposalAddCompRenewalReq.IsHigherPosition = false;
    this.policyInfo = this.objPremiumAndVehicleInfoRes.POLICY_INFO;
    this.policyNo = this.objPremiumAndVehicleInfoRes.POLICY_INFO.POLICYNO;
    if (this.policyInfo.Insured_IBANNO != null || this.policyInfo.Insured_IBANNO != "" || this.policyInfo.Insured_IBANNO != undefined) {
      this.policyInfo.IBAN1 = this.policyInfo.Insured_IBANNO.slice(2, 4);
      this.policyInfo.IBAN2 = this.policyInfo.Insured_IBANNO.slice(4, 8);
      this.policyInfo.IBAN3 = this.policyInfo.Insured_IBANNO.slice(8, 12);
      this.policyInfo.IBAN4 = this.policyInfo.Insured_IBANNO.slice(12, 16);
      this.policyInfo.IBAN5 = this.policyInfo.Insured_IBANNO.slice(16, 20);
      this.policyInfo.IBAN6 = this.policyInfo.Insured_IBANNO.slice(20, 24);
    }


  }


  SaveProposal() {
    if (!this.agreeNatAdd) {
      swal(this.translate.instant("Please agree National Address Declaration"));
      return;
    }

    this.isShowLoading = true;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.proposalAddCompRenewalReq));


    //this.http.post<mdlProposalAddCompRenewalRes>(this.url.baseURL + "Comp_Renewal/ProposalAdd_CompRenewal", this.proposalAddCompRenewalReq, this.userinfo.getHttpOptions()).
    //this.http.post<mdlPayloadResponse>(this.url.baseURL + "Comp_Renewal/ProposalAdd_CompRenewal", this.objPayloadRequest, this.userinfo.getHttpOptions()).
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Comp_Renewal/ProposalAdd_Renewal", this.objPayloadRequest, this.userinfo.getHttpOptions()).
      toPromise().then((res) => {
        this.isShowLoading = false;
        //this.objAddProposalRes = res;

        // //New Line Start
        // this.objPayloadResponse = res;
        // this.objAddProposalRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        // //NewLine End

        // if (this.objAddProposalRes.StatusCode == "1") {

        //   let title: string;
        //   let PopupHeader: string = "Success Message";
        //   title = "Your Proposal Saved Successfully with ProposalNo: " + this.objAddProposalRes.PROPOSALNO;
        //   swal({ title: title, text: "", icon: "success", buttons: [true, true] });

        //   //  sessionStorage.setItem("objAddProposalRes", JSON.stringify(this.objAddProposalRes));
        //   sessionStorage.setItem("objAddProposalRes", this.EncriptService.EncriptObject(JSON.stringify(this.objAddProposalRes)));
        //   this.router.navigate(['/NewDashboard/PayfortPaymentNew/:Confirm']);
        // } else {
        //   //alert(res.ErrorMsg);
        //   let title: string;
        //   let PopupHeader: string = "Failure Message";
        //   title = this.objAddProposalRes.ErrorMsg;
        //   swal({ title: title, text: "", icon: "warning", buttons: [true, true] });
        //   return;
        // }

        //New Line Start
        this.objPayloadResponse = res;
        this.transObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End

        swal(this.transObj.st.StatusDesc);
        if (this.transObj.st.StatusCode === "S") {
          sessionStorage.setItem("NavFrom", "PR");
          //sessionStorage.setItem("transObj", JSON.stringify(this.transObj));
          sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
          sessionStorage.setItem("CurrentRoute", "PayfortPayment");
          this.router.navigate(['/NewDashboard/PayfortPayment']);
        }



      },
        (error) => {

          this.isShowLoading = false;
          this.userinfo.checkTokenStatus(error);
        });

  }

  setBankCode(IBAN) {
    let bankCode: string = IBAN.substring(0, 2)
    this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankCode = bankCode;
    if (IBAN != "" && IBAN != undefined && IBAN != null) {
      if (IBAN.length == 4) {
        let bankCode: string = IBAN.substring(0, 2)
        this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankCode = bankCode;
        if (this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankMaster.filter(t => t.BankCode == bankCode).length > 0) {
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }
      }
    }
  }

  IsHigherPosition(val) {
    if (val == "true") {
      this.proposalAddCompRenewalReq.IsHigherPosition = true;
      this.ShowHigherPositionFeild = true;
    } else {
      this.proposalAddCompRenewalReq.IsHigherPosition = false;
      this.ShowHigherPositionFeild = false;
    }
  }


  CheckVIP(ReviewConfirmForm) {
    this.isSubmitted = true;
    if (!ReviewConfirmForm.valid) {
      return;
    }

    if (this.proposalAddCompRenewalReq.IsHigherPosition == undefined) {
      swal("Please select Is Higher Position");
      return;
    }

    if (this.proposalAddCompRenewalReq.IsHigherPosition == true && this.proposalAddCompRenewalReq.HigherPositionCode == undefined) {
      this.proposalAddCompRenewalReq.HigherPositionCode = 0;
      return;
    } else if (this.proposalAddCompRenewalReq.IsHigherPosition == false) {
      this.proposalAddCompRenewalReq.HigherPositionCode = 0;
      this.CheckValidations();
    } else if (this.proposalAddCompRenewalReq.IsHigherPosition == true && this.proposalAddCompRenewalReq.HigherPositionCode != undefined) {
      this.proposalAddCompRenewalReq.HigherPositionCode = Number(this.proposalAddCompRenewalReq.HigherPositionCode);
      if (ReviewConfirmForm.valid) {
        this.CheckValidations();
      }
    }
  }
  ///<<<<<<<<<<<<<< CheckValidations Start>>>>>>>>>>>>>>>>>>>>>>>
  CheckValidations() {
    this.proposalAddCompRenewalReq.ScreenShot = sessionStorage.getItem("ScreenShot");
    this.proposalAddCompRenewalReq.Insured_IBANNO = "SA" + this.policyInfo.IBAN1 + this.policyInfo.IBAN2 + this.policyInfo.IBAN3 + this.policyInfo.IBAN4 + this.policyInfo.IBAN5 + this.policyInfo.IBAN6;
    this.objPremiumAndVehicleInfoRes.POLICY_INFO.Insured_IBANNO = this.proposalAddCompRenewalReq.Insured_IBANNO;
    this.proposalAddCompRenewalReq.POLICYNO = this.policyNo;
    this.proposalAddCompRenewalReq.BankName = this.policyInfo.BankCode;
    this.proposalAddCompRenewalReq.Insured_EmailId = this.policyInfo.Insured_EmailId;
    this.proposalAddCompRenewalReq.CoverDetails = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails;
    this.proposalAddCompRenewalReq.Insured_IDNo = this.policyInfo.Insured_Id;
    //sessionStorage.setItem("objPremiumAndVehicleInfoRes", JSON.stringify(this.objPremiumAndVehicleInfoRes));


    if (this.proposalAddCompRenewalReq.Insured_IBANNO == null) {
      swal("Please Enter IBAN Number to proceed");
      return;
    }
    else {
      if (this.proposalAddCompRenewalReq.Insured_IBANNO.length != 24) {
        swal("IBAN Number must be 24 digits");
        return;
      }
    }

    if (this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankCode == null) {
      swal("BankCode is Required");
      return;
    }
    else {
      let ChkBank = 0;
      let BankMaster = this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankMaster;
      for (let Bank of BankMaster) {
        if (Bank.BankCode == this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankCode) {
          ChkBank = 1;
        }
      }
      if (ChkBank == 0) {
        swal("Please Enter Valid Bank Code");
        return;
      }

    }

    let title: string;
    let PopupHeader: string = "Certify And Confirm";
    title = "I certify and confirm that all the information furnished/provided by me in/with this application form is true, full & complete to best of my knowledge & belief";
    if (this.Lng == "ar") {
      title = "أقر أن جميع المعلومات التي عرضت / قدمت في هذا الطلب هي معلومات صحيحة وكاملة . وبعلم وإيقان كامل من طرفي";
      PopupHeader = "تأكيد البيانات";
    }
    swal({ title: title, text: "", icon: "warning", buttons: [true, true] }).then((result) => {
      if (result) {
        this.SaveProposal();
      }
    });


  }
  ///<<<<<<<<<<<<<< CheckValidations End>>>>>>>>>>>>>>>>>>>>>>>




  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  iban1Changed(event) {

    if (event != "" && event != undefined && event != null) {
      if (event.length == 2) {
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }

  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {
      //alert(event.length);
      if (event.length == 4) {
        let bankCode: string = event.substring(0, 2)
        this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankCode = bankCode;
        if (this.objPremiumAndVehicleInfoRes.POLICY_INFO.BankMaster.filter(t => t.BankCode == bankCode).length > 0) {
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }


      }
    }
  }

  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }

  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }

  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }



  Previous() {

    this.router.navigate(['NewDashboard/CompRenewalProposal/CompRenewalPremiumInfo']);
  }

  ValidateSpecialCharacters(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k > 1500 && k < 1650) || k == 8 || k == 32);
  }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalReviewConfirm/CompRenewalReviewConfirm.ts